import type { Node as ProseMirrorNode } from "prosemirror-model";
import { Fragment } from "prosemirror-model";

import { focusSchema } from "../schema";
import { formatSourceMarkdownImage } from "./source-utils";

const paragraphBreakPattern = /\n{2,}/;

const createInlineSourceContent = (text: string) => {
  const children: ProseMirrorNode[] = [];
  const lines = text.split("\n");

  lines.forEach((line, index) => {
    if (index > 0) {
      children.push(focusSchema.nodes.hard_break.create());
    }

    if (line) {
      children.push(focusSchema.text(line));
    }
  });

  return Fragment.fromArray(children);
};

const serializeInlineSourceContent = (node: ProseMirrorNode) => {
  const chunks: string[] = [];

  node.forEach((child) => {
    if (child.isText) {
      chunks.push(child.text ?? "");
      return;
    }

    if (child.type.name === "hard_break") {
      chunks.push("\n");
      return;
    }

    if (child.type.name === "mention") {
      chunks.push(`${child.attrs.trigger || "@"}${child.attrs.username}`);
      return;
    }

    if (child.type.name === "image") {
      chunks.push(
        formatSourceMarkdownImage({
          alt: child.attrs.alt,
          src: child.attrs.src || "",
          title: child.attrs.title,
        }),
      );
    }
  });

  return chunks.join("");
};

export const parseMarkdownSourceToDoc = (markdown: string) => {
  const blocks = markdown ? markdown.split(paragraphBreakPattern) : [""];

  return focusSchema.nodes.doc.create(
    null,
    Fragment.fromArray(
      blocks.map((block) =>
        focusSchema.nodes.paragraph.create(
          null,
          createInlineSourceContent(block),
        ),
      ),
    ),
  );
};

export const serializeMarkdownSourceDoc = (doc: ProseMirrorNode) => {
  const blocks: string[] = [];

  doc.forEach((node) => {
    if (node.type.name === "paragraph") {
      blocks.push(serializeInlineSourceContent(node));
      return;
    }

    blocks.push(node.textContent);
  });

  return blocks.join("\n\n").trim();
};
